import { useEffect, useRef, useState } from 'react';

const useContainerWidthListener = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [width, setWidth] = useState(0);

  const observerRef = useRef<ResizeObserver | null>(
    new ResizeObserver(() => {
      setWidth(containerRef.current?.offsetWidth || 0);
    })
  );

  useEffect(() => {
    if (containerRef.current) {
      observerRef.current?.observe(containerRef.current);
    }
  }, []);

  return { containerRef, width };
};
export default useContainerWidthListener;
